<template>
    <div class="col-xs-12">

        <div class="block block-bordered block-themed block-content">

            <div class="form-group"> 
                    <h3 class="font-w300 push-10 align-center">{{ graphData.title[actualLanguage] }}</h3>



                    <div class="input-daterange form-group row">
                        <div class="input-date-time-picker" >
                            <div class="col-xs-12">
                                    <div class="col-lg-4 col-md-6 col-xs-12">
                                        <div class="col-md-6">
                                            <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                                            <date-picker
                                                class="el-input__inner form-control"
                                                v-model="myStartDate"
                                                type="date"
                                                placeholder=""
                                                clear-icon=""
                                                format="yyyy-MM-dd"
                                                value-format="timestamp"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                                            <time-select
                                                v-model="startTime"
                                                placeholder=""
                                                clear-icon=""
                                                :picker-options="{
                                                    start: '00:00',
                                                    step: '01:00',
                                                    end: '24:00'
                                                }"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-md-6 col-xs-12">
                                        <div class="col-md-6">
                                            <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                                            <date-picker
                                                class="el-input__inner form-control"
                                                v-model="myEndDate"
                                                type="date"
                                                placeholder=""
                                                clear-icon=""
                                                format="yyyy-MM-dd"
                                                value-format="timestamp"
                                            />
                                        </div>
                                        <div class="col-md-6">
                                            <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                                            <time-select
                                                v-model="endTime"
                                                placeholder=""
                                                clear-icon=""
                                                :picker-options="{
                                                    start: '00:00',
                                                    step: '01:00',
                                                    end: '24:00'
                                                }"
                                            />
                                        </div>
                                    </div>
                                

                                    <div class="col-lg-4 col-md-6 col-xs-12">
                                        <div class="col-xs-12 push">
                                            <div class="form-group">
                                                <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>

                                                <div class="col-xs-6">
                                                    <select class="form-control" v-model=dataSamplingSelect size="1">
                                                        <option value="Automatic">{{labelDataSamplingAuto[actualLanguage]}}</option>
                                                        <option value="5min">{{labelDataSampling5min[actualLanguage]}}</option>
                                                        <option value="Hour">{{labelDataSamplingHour[actualLanguage]}}</option>
                                                        <option value="Day">{{labelDataSamplingDays[actualLanguage]}}</option>
                                                    </select>
                                                </div>

                                                <div class="col-xs-6">
                                                    <button type="button" @click="refreshGraph()" class="btn btn-success" name="button"><spinner size="small" v-if="flagGraphDataIsLoading"></spinner>
                                                    <span v-else><i class="fa fa-repeat pull-left"></i>{{ labelButtonRefresh[actualLanguage] }}</span></button>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>








                    </div>




                    <spinner size="small" v-if="dataIsLoading"></spinner>
                    <div v-else class="row">

                        <div class="col-sm-12 col-md-12">
                            <select @change="updateChartData" v-model="selectedTraceIndex" class="js-select2">
                                <option v-for="(trace,index) in graphData.traces" v-bind:value="index">{{ trace.label[actualLanguage] }}</option>
                            </select>
                        </div>

                        <div v-if="flagDisplayGraph"  class="col-sm-12 col-md-12">

                            <div class="col-sm-12">
                             <line-chart :chartData="crunchedData" ></line-chart>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-xm-12 col-sm-3">
                                    <label class="align-right">{{ labelTimeSpan[actualLanguage] }}</label>
                                </div>
                                <div class="col-xm-12 col-sm-9">
                                    <div class="col-sm-9">
                                        <input type="range" @change="updateChartData()" class="custom-range" id="customRange1" v-model="graphTimeSpan">
                                    </div>
                                    <div class="col-sm-3">
                                        <label>{{graphTimeSpan}}/100%</label>
                                        
                                    </div> 
                                </div>                               
                            </div>

                            <div class="col-sm-12">
                                <div class="col-xm-12 col-sm-3">
                                    <label class="align-right">{{ labelTimeCenter[actualLanguage] }}</label>
                                </div>
                                <div class="col-xm-12 col-sm-9">
                                    <div class="col-sm-9">
                                        <input type="range" @change="updateChartData()" class="custom-range" id="customRange1" v-model="graphTimeCenter">
                                    </div>
                                    <div class="col-sm-3">
                                        <label>{{graphTimeCenter}}/100%</label>
                                    </div>
                                </div>                               
                            </div>

                        </div>

                    </div>


        <!--
                    <div v-if="true" class="col-xs-12 col-sm-12 align-center">
                        <download-csv class = "btn btn-default" :data = "histogramDataDownloadDay" name = "ChannelHistogramDayData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
                    </div>
        -->            
        </div>
    </div>
        

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import Spinner from '../../../components/Spinner.vue'
import LineChart from '@/components/LineChart'

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)


import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  props: ['graphData'],
  data() {
    return {
        timeRange : 0,
        actualLanguage : "FR",
        dataIsLoading:false,
        flagDisplayGraph:false,
        flagGraphDataIsLoading : false,
        movingAverageData:[],
        crunchedData:{},
        selectedTraceIndex : 0,

        //Variable de sélection pour visualiser une sous section
        graphTimeSpan : 100,
        graphTimeCenter : 50,

        myStartDate: '',
        myEndDate: '',
        startTime: '00:00',
        endTime: '00:00',
        myStartDateTime : this.startDate,
        myEndDateTime : this.endDate,
        dataSamplingSelect : 'Automatic',

        displayTraceFlag : [],

        graphTitle: {FR: "Puissance moyenne (Watts)", EN: 'Average power (Watts)'},
        buttonLabelMA: {FR: "Moyenne", EN: 'Average'},
        buttonLabelMA_Days: {FR: "jours", EN: 'days'},
        graphLabelLastReading: {FR: "Dernière mesure", EN: 'Last reading'},

        labelStartDate: {FR: 'Date de début', EN: 'Start date'},
        labelStartTime: {FR: 'Heure de début', EN: 'Start time'},

        labelEndDate: {FR: 'Date de fin', EN: 'End date'},
        labelEndTime: {FR: 'Heure de fin', EN: 'End time'},

        labelButtonRefresh: {FR: 'Rafraichir', EN: 'Refresh'},

        labelDataSamplingTitle: {FR: 'Type de données :', EN: 'Data type :'},
        labelDataSamplingAuto: {FR: 'Automatique', EN: 'Automatic'},
        labelDataSampling5min: {FR: 'Données brutes', EN: 'Raw data'},
        labelDataSamplingHour: {FR: 'Heure', EN: 'Hour'},
        labelDataSamplingDays: {FR: 'Jour', EN: 'Days'},

        labelTimeSpan: {FR: 'Plage de temps (%)', EN: 'Time span (%)'},
        labelTimeCenter: {FR: 'Centre de temps (%)', EN: 'Time center (%)'},        

    }
  },

  components: {
    LineChart,
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect,
  },

  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {

    refreshGraph(){
        this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
        this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)
        
        },



    updateChartData(){

        let dynamicDataset = []
        this.flagDisplayGraph = false

        let firstIndex = 0
        let lastIndex = this.graphData.xData.length


        //Calcul des indice en fonction des sélecteur de time span
        firstIndex = Math.round(((parseInt(this.graphTimeCenter)-parseInt(this.graphTimeSpan)/2)/100) * this.graphData.xData.length)
        if (firstIndex < 0 ){firstIndex = 0}
        lastIndex = Math.round(((parseInt(this.graphTimeCenter)+parseInt(this.graphTimeSpan)/2)/100) * this.graphData.xData.length)
        if (lastIndex > this.graphData.xData.length ){lastIndex = this.graphData.xData.length}


        dynamicDataset.push({
            label: this.graphData.traces[this.selectedTraceIndex].label[this.actualLanguage],
            backgroundColor: 'rgba(70, 195, 123, 0.1)',
            borderColor: 'rgba(5, 210, 92, .25)',
            pointBackgroundColor: 'rgba(68, 180, 166, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
            data: this.graphData.traces[this.selectedTraceIndex].yData.slice(firstIndex,lastIndex),
            //data: _.map(this.graphData.traces[m].yData, function(data){ return data.MA_001H; })
        }) 



        this.crunchedData = {
        //labels: _.map(this.movingAverageData, function(data){ return data.timestamp; }),
        labels: this.graphData.xData.slice(firstIndex,lastIndex),
        datasets: dynamicDataset
      }

        this.$nextTick(() => {
          this.flagDisplayGraph = true
        });
      
    },

    formatTimeToUnix(date, time) {
        const unixTime = moment(date)
        .set('hour', time.split(':')[0])
        .set('minute', time.split(':')[1])
        .set('seconds', 0)
        .unix()

        return unixTime
    },

  },
  mounted() {

    this.timeRange = this.endDate - this.startDate


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    for(var m=0;m<this.graphData.traces.length;m++){
        this.displayTraceFlag.push(true)
    }


    this.myStartDate = new Date(this.startDate * 1000),
    this.myEndDate = new Date(this.endDate * 1000)


    var DateStringSplit = this.myStartDate.toString().split(':')
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]

    DateStringSplit = this.myEndDate.toString().split(':')
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]
    
    
    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)

    if(this.graphData.traces.length > 0){this.updateChartData()}
    //this.getMovingAverageLogData()


  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// ApiDeviceGraphLineSingleV1p00.vue?6c6286b8